export class LameSondeCalculator {
  lame: string;
  sonde: string;
  
  public getLameSonde(weight: number) : { lame: string, sonde: string} {
    if (weight < 3) {
      this.lame = "Miller droite n°0-1";
      this.sonde = "n°2.5-3";
    }
    else if (weight === 3) {
      this.lame = "Miller droite n°0-1";
      this.sonde = "n°3-3.5";
    }
    else if (weight <= 7.5) {
      this.lame = "Miller droite n°1";
      this.sonde = "n°3-3.5";
    } else if (weight < 10) {
      this.lame = "Miller droite n°1";
      this.sonde = "n°3.5";
    } else if (weight === 10) {
      this.lame = "Miller droite n°1";
      this.sonde = "n°3.5-4";
    } else if (weight <= 12) {
      this.lame = "Mac courbe n°2";
      this.sonde = "n°4";
    } else if (weight === 15) {
      this.lame = "Mac courbe n°2";
      this.sonde = "n°4-5";
    } else if (weight < 18) {
      this.lame = "Mac courbe n°2";
      this.sonde = "n°4.5-5";
    } else if (weight === 18) {
      this.lame = "Mac courbe n°2";
      this.sonde = "n°5";
    }
    else if (weight < 24) {
      this.lame = "Mac courbe n°2";
      this.sonde = "n°5-6";
    } else if (weight === 24) {
      this.lame = "Mac courbe n°2";
      this.sonde = "n°6";
    }
    else if (weight < 30) {
      this.lame = "Mac courbe n°2";
      this.sonde = "n°6-6.5";
    } else if (weight === 30) {
      this.lame = "Mac courbe n°2";
      this.sonde = "n°6.5";
    }
    else if (weight < 37) {
      this.lame = "Mac courbe n°2-3";
      this.sonde = "n°6.5-7";
    } else if (weight === 37) {
      this.lame = "Mac courbe n°3";
      this.sonde = "n°7";
    }
    else if (weight < 70) {
      this.lame = "Mac courbe n°4";
      this.sonde = "n°7.5";
    } else if (weight >= 70) {
      this.lame = "Mac courbe n°4";
      this.sonde = "n°8";
    }

    return { lame: this.lame, sonde: this.sonde}
  }
}



// WEBPACK FOOTER //
// ./src/models/lame-sonde-calculator.ts